export const defaultLngCode = 'en';
export const defaultNs = 'common';
